export default "__VITE_PUBLIC_ASSET__47f00c95__"